<template>
    <div class="dropdown" v-if="tags_list.length>0">
        <b-button-group>
            <button class="btn btn-white" @click="clear" v-if="localValue && localValue.length>0">
                <span class="fe fe-x"></span>
            </button>
            <b-dropdown variant="white" right :text="label">
                <div
                    v-for="(tag, index) in tags_list"
                    :key="index"
                    class="dropdown-item pl-3 border-right border-3"
                    :class="'border-' + tag.color"
                >
                    <b-form-checkbox v-model="localValue" :value="tag._id">{{tag.tag}}</b-form-checkbox>
                </div>
            </b-dropdown>
        </b-button-group>
    </div>
</template>
<script>

import { mapActions, mapState, mapGetters } from 'vuex';

export default {
    name: 'Tags',
    props: ['value', 'label'],
    data() {
        return {
            localValue: [],
        }
    },

    created() {
        this.localValue = this.value;
    },
    watch: {
        localValue(newValue) {
            this.$emit('input', newValue);
        }
    },
    computed: {
        ...mapGetters('tags', { findTagsInStore: 'find' }),
        tags_list() {
            return this.findTagsInStore().data;

        },

    },
    methods: {
        clear() {
            this.localValue = [];
        },
        memberStyles(color) {
            return 'border-right:3px solid ' + color;
        },
        updateValue(value) {
            this.localValue = value;
        },
    }

}
</script>